import React, { useState } from "react";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import Navbar from "../../components/Navbar/Navbar";
import TextInput from "../../components/TextInput/TextInput";
import { passwordValidator } from "../../helpers/passwordValidator";

/**Firebase Imports**/
import {
	auth,
	EmailAuthProvider,
	reauthenticateWithCredential,
	updatePassword,
} from "../../firebaseConfig";
import { showError } from "../../helpers/showError";
/** **/

const SettingsScreen = () => {
	const [oldPass, setOldPass] = useState({ value: "", error: "" });
	const [newPass, setNewPass] = useState({ value: "", error: "" });
	const [confirmPass, setConfirmPass] = useState({ value: "", error: "" });
	const [isProcessing, setIsProcessing] = useState(false);

	/**
	 * Main Functions
	 */
	const handleUpdate = async () => {
		setIsProcessing(true);
		if (!checkErrors()) {
			setIsProcessing(false);
			return;
		}
		const credential = EmailAuthProvider.credential(
			auth.currentUser.email,
			oldPass.value
		);
		reauthenticateWithCredential(auth.currentUser, credential)
			.then((data) => {
				updatePassword(data.user, newPass.value)
					.then(() => {
						alert("Password updated successfully.");
						setOldPass({ value: "", error: "" });
						setNewPass({ value: "", error: "" });
						setConfirmPass({ value: "", error: "" });
						setIsProcessing(false);
					})
					.catch((error) => {
						showError(error);
						setIsProcessing(false);
					});
			})
			.catch((error) => {
				setOldPass({
					value: oldPass.value,
					error:
						"*" +
						error.code
							.toString()
							.split("-")
							.join(" ")
							.split("/")
							.join(" error:  "),
				});
				setIsProcessing(false);
			});
	};

	/**
	 * Utility Functions
	 */
	function checkErrors() {
		var noErrors = true;
		const newPassError = passwordValidator(newPass.value);
		const confirmPassError =
			newPass.value === confirmPass.value ? "" : "*Passwords don't match.";

		// check empty
		if (oldPass.value === "") {
			setOldPass({
				value: oldPass.value,
				error: "*Password can't be empty.",
			});
			noErrors = false;
		}
		if (confirmPass.value === "") {
			setConfirmPass({
				value: confirmPass.value,
				error: "*Password can't be empty.",
			});
			noErrors = false;
		}

		// check empty and valid
		if (newPassError) {
			setNewPass({
				value: newPass.value,
				error: newPassError,
			});
			noErrors = false;
		}
		// check same passwords
		if (confirmPassError) {
			setConfirmPass({
				value: confirmPass.value,
				error: confirmPassError,
			});
			noErrors = false;
		}
		return noErrors;
	}

	return (
		<div className="VariableCostScreen h-full w-full overflow-y-auto m-0 p-3 py-8">
			<div className="h-full w-full m-0 p-0">
				<Navbar backTarget={"/landing"} />

				<Header className={"my-8 text-center"} size={"medium"}>
					SETTINGS
				</Header>

				<TextInput
					placeholder={"Old Password"}
					className={"my-2 shadow-none"}
					type={"password"}
					name={"oldPass"}
					id={"oldPass"}
					value={oldPass.value}
					onChange={(e) => {
						setOldPass({ value: e.target.value, error: "" });
					}}
					error={oldPass.error !== ""}
					errorMessage={oldPass.error}
				/>

				<TextInput
					placeholder={"New Password"}
					className={"my-2 shadow-none"}
					type={"password"}
					name={"newPass"}
					id={"newPass"}
					value={newPass.value}
					onChange={(e) => {
						setNewPass({ value: e.target.value, error: "" });
					}}
					error={newPass.error !== ""}
					errorMessage={newPass.error}
				/>

				<TextInput
					placeholder={"Confirm Password"}
					className={"my-2 shadow-none"}
					type={"password"}
					name={"confirmPass"}
					id={"confirmPass"}
					value={confirmPass.value}
					onChange={(e) => {
						setConfirmPass({ value: e.target.value, error: "" });
					}}
					error={confirmPass.error !== ""}
					errorMessage={confirmPass.error}
				/>

				<Button
					mode={"filled"}
					size={"lg-1"}
					title={isProcessing ? "ooo" : "UPDATE PASSWORD"}
					disabled={isProcessing}
					className={"my-6"}
					onClick={() => {
						handleUpdate();
					}}
				/>
			</div>
		</div>
	);
};

export default SettingsScreen;
